<template>
  <div>
    <v-card
      flat
      class="mb-5 mt-5 scrollToAddQuestion"
      color="Neutral"
      style="background-color: transparent !important"
    >
      <!-- <v-btn small dark color="pageHeader" @click="addQuestions">
        {{ $t("poll.btnAddQuestion") }}
      </v-btn> -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
      <a-btn color="primaryDark" @click="addQuestions" v-bind="attrs" v-on="on">
        {{ $t("poll.btnAddQuestion") }}</a-btn
      >
      </template>
        <span>{{ $t("poll.btnAddQuestion") }} </span>
      </v-tooltip>
    </v-card>
    <transition name="slide-fade">
      <!-- :max-width="placedInSection ? '100%' : '80%'" -->
      <v-card
        v-if="showQuestionTypeOptions"
        flat
        :class="placedInSection ? 'scrollToMe mb-5' : 'scrollToMe mb-5'"
        style="background-color: #f5f5f5"
      >
        <!-- <v-btn-toggle dense>
          <v-btn
            v-for="question in answerOptions"
            :key="question.value"
            :value="question.value"
            :disabled="question.disabled ? question.disabled : false"
            @click="onOptionClick(question)"
          >
            <v-icon left color="primary">{{ question.icon }} </v-icon>
            <span class="hidden-sm-and-down">{{ question.text }}</span>
          </v-btn>
        </v-btn-toggle> -->
        <v-btn-toggle
          active-class="toggle-active-class"
          class="a-toggle-button"
          dense
        >
          <a-btn
            v-for="question in answerOptions"
            :key="question.value"
            :value="question.value"
            :disabled="question.disabled ? question.disabled : false"
            @click="onOptionClick(question)"
          >
            <v-icon left color="primary">{{ question.icon }} </v-icon>
            <span class="hidden-sm-and-down">{{ question.text }}</span>
          </a-btn>
        </v-btn-toggle>
      </v-card>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AddQuestionCard",
  props: {
    maxWidth: {
      type: String,
      default: "80%",
    },
    sectionId: String,
    panel: Number,
    placedInSection: {
      type: true,
      default: false,
    },
  },
  data() {
    return {
      showQuestionTypeOptions: false,
      //   sectionId: null,
    };
  },
  computed: {
    answerOptions() {
      return [
        {
          text: this.$t("poll.lblChoice"),
          value: "choice",
          icon: "mdi-radiobox-marked",
        },
        {
          text: this.$t("poll.lblText"),
          value: "textType",
          icon: "mdi-text-short",
        },
        { text: this.$t("poll.lblRating"), value: "rating", icon: "mdi-star" },
        { text: this.$t("poll.lblLikert"), value: "likert", icon: "mdi-grid" },
        {
          text: this.$t("poll.lblSection"),
          value: "section",
          icon: "mdi-selection-multiple",
        },
      ];
    },
  },
  methods: {
    addQuestions,
    onOptionClick,
    scrollToElement,
  },
};

function onOptionClick(question) {
  this.$root.$emit("add-question-option", question, this.sectionId);
  this.showQuestionTypeOptions = false;
  this.$nextTick(() => {
    this.scrollToElement("scrollToAddQuestion");
  });
}

function addQuestions() {
  this.showQuestionTypeOptions = !this.showQuestionTypeOptions;
  this.$nextTick(() => {
    this.scrollToElement("scrollToMe");
  });
}

function scrollToElement(target) {
  const el = this.$el.getElementsByClassName(target)[0];
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
</script>

<style scoped>
.a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}
</style>